module.exports = __webpack_public_path__ + "static/image4_fr-f4689c41ab52937c091244ebde63a0ef.png";